/**
 * Market stall data — Camden-specific destructible environment objects.
 * Pure; no Phaser imports.
 */

export type StallDropKind = 'weapon' | 'food';

export interface StallDef {
  readonly id: string;
  readonly label: string;
  /** Optional sprite atlas assetId for rendered stall art. */
  readonly assetId?: string;
  /** Placeholder fill colour. */
  readonly color: number;
  /** Hits required to destroy. */
  readonly health: number;
  readonly dropKind: StallDropKind;
  /** Weapon def id to drop (only when dropKind === 'weapon'). */
  readonly dropWeaponId?: string;
  /** HP amount to restore (only when dropKind === 'food'). */
  readonly dropHeal?: number;
}

/** Placement of a market stall within a stage level. */
export interface StallPlacement {
  /** References a StallDef id in MARKET_STALLS. */
  readonly stallId: string;
  /** Horizontal position as a fraction of levelWidth (0–1). */
  readonly xFrac: number;
}

export const MARKET_STALLS: readonly StallDef[] = [
  {
    id: 'camden-fish-stall',
    label: 'FISH STALL',
    assetId: 'camden-fish-stall',
    color: 0x4a7fa5,
    health: 3,
    dropKind: 'weapon',
    dropWeaponId: 'pipe',
  },
  {
    id: 'camden-kebab-van',
    label: 'KEBAB VAN',
    assetId: 'camden-kebab-van',
    color: 0xc05c2a,
    health: 4,
    dropKind: 'food',
    dropHeal: 15,
  },
  {
    id: 'camden-vinyl-stall',
    label: 'VINYL STALL',
    assetId: 'camden-vinyl-stall',
    color: 0x7a3f8c,
    health: 3,
    dropKind: 'weapon',
    dropWeaponId: 'bat',
  },
  {
    id: 'camden-chips-stall',
    label: 'CHIPS',
    assetId: 'camden-chips-stall',
    color: 0xd4a520,
    health: 2,
    dropKind: 'food',
    dropHeal: 10,
  },
];

/** Look up a stall definition by id. Returns undefined if not found. */
export function getStallDef(id: string): StallDef | undefined {
  return MARKET_STALLS.find((s) => s.id === id);
}
